<template>
    <div class="dropdown">
        <span class="dropdown-trigger" :class="triggerClass" @click="toggle">
            <slot name="trigger"></slot>
        </span>

        <div ref="body" :class="'dropdown-menu panel ' + classes" v-show="isOpened">
            <div class="dropdown-body">
                <slot name="body"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            vertical: {
                default: 'bottom'
            },
            horizontal: {
                default: 'left'
            },
            triggerClass: {
                default: ""
            }
        },
        data() {
            return {
                isOpened: false
            };
        },
        methods: {
            toggle() {
                this.isOpened = !this.isOpened;
                if (this.isOpened) {
                    this.$globalEvents.$emit('dropdown:open', this);
                }
            }
        },
        computed: {
            classes() {
                const horizontalClass = this.horizontal === 'right'? 'dropdown-right' : 'dropdown-left',
                    verticalClass = this.vertical === 'bottom'? 'dropdown-bottom' : 'dropdown-top';

                return horizontalClass + ' ' + verticalClass;
            }
        },
        mounted() {
            this.$globalEvents.$on('dropdown:open', (instance) => {
                if (instance !== this) {
                    this.isOpened = false;
                }
            });
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_variables.scss";

    .dropdown {
        position: relative;
        display: inline-block;

        .dropdown-trigger {
            cursor: pointer;
            outline: none;
            user-select: none;
        }

        .dropdown-menu {
            z-index: 9998;
            box-shadow: 0 7px 10px 0 rgba(0, 0, 0, 0.08);
            width: 300px;
            border-radius: 4px;
            margin-top: 10px;
            overflow: visible;
            position: absolute;
            display: block;
            font-size: 13px;

            &:before {
                border-left: 7px solid transparent;
                border-right: 7px solid transparent;
                content: "";
                display: inline-block;
                position: absolute;
            }

            .dropdown-body {
                ul li {
                    display: block;
                    width: 100%;

                    a {
                        display: block;
                        padding: 5px;
                        border-radius: 3px;
                        position: relative;

                        &:active, &:hover {
                            background-color: #f1f3f5;
                        }
                    }
                }
            }

            &.dropdown-top {
                bottom: 100%;
                top: auto;
                margin-bottom: 10px;

                &:before {
                    border-top: 7px solid #FAFBFF;
                    bottom: -7px
                }
            }

            &.dropdown-bottom {
                bottom: auto;
                top: 100%;
                margin-top: 10px;

                &:before {
                    border-bottom: 7px solid #FAFBFF;
                    top: -7px;
                }
            }

            &.dropdown-left {
                left: 0;
                right: auto;

                &:before {
                    left: 9px;
                }
            }

            &.dropdown-right {
                right: 0;
                left: auto;

                &:before {
                    right: 9px;
                }
            }
        }
    }
</style>
